module.exports = __webpack_public_path__ + "static/media/Sharjah-Int-Charity.a9205a7d.jpg";